import { collectUtmParameters, currentPath } from './helpers'

const UTM_PARAMS = collectUtmParameters();
const SOURCE = 'itm_source';
const MEDIUM = 'itm_medium';
const CAMPAIGN = 'itm_campaign';
const TERM = 'itm_term';

const reviewAppURL = 'https://pkwde-pr-2581.herokuapp.com/api/v1';
const stagingURL = 'https://pkw-test.viscomp.net/api/v1';
const productionURL = 'https://www.pkw.de/api/v1';

const isStaging = process.env.VUE_APP_ENV === 'test';
export const BASE = isStaging ? stagingURL : productionURL;

export const Endpoints = {

  get: function (name, state) {

    const make = state.selected.make;
    const model = state.selected.model;
    const year = state.selected.year;
    const month = state.selected.month;
    const bodytype = state.selected.bodytype;
    const fuel = state.selected.fuel;
    const engine = state.selected.engine;
    const power = state.selected.power;
    const equipment = state.selected.equipment;
    const schwacke = state.selected.schwacke;
    const mileage = state.selected.mileage;
    const extras = state.selected.extras || [];
    const email = state.selected.email;
    const zip = state.selected.zip;
    const location = state.selected.location;
    const purpose = state.selected.purpose;
    const valuation = state.selected.valuation;
    const token = state.token || currentPath()['id'];
    const dealerForm = state.selected.dealerForm || {};
    const dealerKey = state.dealerKey;

    const feedback = state.lead != null ? state.lead.evaluation_feedback : null;

    const arrayOfExtras = extras.reduce((acc, item, index, arr) => {
      return index + 1 < arr.length ? acc += `extras[]=${item}&` : acc += `extras[]=${item}`;
    }, '');

    const options = {
      make: {
        url: `/procurement/brands`,
        params: null,
        base: true
      },
      model: {
        url: `/procurement/brands/${make}/models`,
        params: null,
        base: true
      },
      year: {
        url: `/procurement/models/${model}/production_years`,
        params: null,
        base: true
      },
      bodytype: {
        url: `/procurement/models/${model}/${year}/body_types`,
        params: null,
        base: true
      },
      fuel: {
        url: `/procurement/models/${model}/${year}/fuel_types`,
        params: { body_type: bodytype },
        base: true
      },
      power: {
        url: `/procurement/models/${model}/${year}/engines`,
        params: {
          body_type: bodytype,
          fuel_type: fuel
        },
        base: true
      },
      engine: {
        url: `/procurement/models/${model}/${year}/engines`,
        params: {
          body_type: bodytype,
          fuel_type: fuel
        },
        base: true
      },
      equipment: {
        url: `/procurement/models/${model}/${year}/equipments`,
        params: {
          body_type: bodytype,
          engine: engine,
          power: power
        },
        base: true
      },
      extras: {
        url: `/procurement/models/${model}/${year}/car`,
        params: {
          body_type: bodytype,
          engine: engine,
          power: power,
          equipment: equipment
        },
        base: true
      },
      valuation: {
        url: `/procurement/cars/${schwacke}/valuate?${location != null ? 'region_id=' + location + '&' : ''}mileage=${mileage}&${arrayOfExtras}&initial_registration=${year}-${month}`,
        params: null,
        base: true
      },
      autocomplete: {
        url: `/autocomplete/zip?term=${zip}`,
        params: null,
        base: true
      },
      createLead: {
        url: `/opt_in/procurement/leads`,
        body: Object.assign({}, valuation, {
          email: email,
          mileage: mileage,
          schwacke_car_id: schwacke,
          region_id: location,
          motivation: purpose,
          initial_registration: `${year}-${month}`,
          [MEDIUM]: UTM_PARAMS[MEDIUM],
          [SOURCE]: UTM_PARAMS[SOURCE],
          [CAMPAIGN]: UTM_PARAMS[CAMPAIGN],
          [TERM]: UTM_PARAMS[TERM],
        }),
        base: true
      },
      createWidgetLead: {
        url: `/opt_in/procurement/leads`,
        body: Object.assign({}, valuation, {
          source: 'plugin',
          mileage: mileage,
          dealer: dealerKey,
          phone: dealerForm.phone,
          email: dealerForm.email,
          schwacke_car_id: schwacke,
          user: dealerForm.username,
          message: dealerForm.message,
          initial_registration: `${year}-${month}`,
          [MEDIUM]: UTM_PARAMS[MEDIUM],
          [SOURCE]: UTM_PARAMS[SOURCE],
          [CAMPAIGN]: UTM_PARAMS[CAMPAIGN],
          [TERM]: UTM_PARAMS[TERM],
        }),
        base: true
      },
      getLead: {
        url: `/procurement/leads/${token}`,
        params: null,
        base: true
      },
      updateFeedback: {
        url: `/procurement/leads/${token}/feedback`,
        body: {
          evaluation_feedback: feedback != null ? feedback.feedback : null,
          evaluation_feedback_expected_price: feedback != null ? feedback.expected_price == "" ? null : feedback.expected_price : null,
        },
        base: true
      },
      fees: {
        url: `/procurement/fees`,
        params: null,
        base: true
      }
    }

    let endpoint = options[name];

    if (endpoint.base) {
      endpoint.url = `${BASE}${endpoint.url}`
    }

    if (name === "createLead") {
      // Save to local storage selected configuration to show summary on print mode with all details
      try {
        const makeName = state.options.make.find((m) => m.id === make).name;
        const modelName = state.options.model.find((m) => m.id === model).name;
        const bodytypeName = state.options.bodytype.find((m) => m.id === bodytype).name;
        const fuelName = state.options.fuel.find((m) => m.id === fuel).name;
        const powerName = state.options.power.find((m) => m.id === power).name;
        const _extras = (state.selected.extras || [])
          .map((extra) => {
            const result = state.options.extras.find(sourceItem => sourceItem.id === extra);
            if (!!result.name) { return result.name }
          })
          .join(", ");

        const data = {
          make: makeName,
          model: modelName,
          power: powerName,
          fuel: fuelName,
          bodytype: bodytypeName,
          equipment,
          mileage,
          engine,
          year,
          month,
          extras: _extras
        };

        localStorage.setItem('pkw_selected', JSON.stringify(data));
      } catch (e) { }
    }

    for (let i in endpoint.params) {
      if (endpoint.params[i] == "-1") { endpoint.params[i] = null }
    }

    return endpoint;
  }
}



// WEBPACK FOOTER //
// ./src/services/endpoints.js